import { render, staticRenderFns } from "./AtomLabel.vue?vue&type=template&id=5f279eaa"
import script from "./AtomLabel.vue?vue&type=script&lang=js"
export * from "./AtomLabel.vue?vue&type=script&lang=js"
import style0 from "./AtomLabel.vue?vue&type=style&index=0&id=5f279eaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports